export default __webpack_public_path__ + "static/media/i-host@3x.36226fcd.webp";